import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { setSelected } from "../redux/eventLogsSaga";

import MultiSelectDropdown from "../../../../components/multiSelectDropdown/multiSelectDropdown";

const TableTypeDropdown = () => {
  const dispatch = useDispatch();
  const options = useSelector((state) => state.eventLogs.options.tableType);
  const selectedFilters = useSelector((state) => state.eventLogs.selected.tableType);

  const onTableTypeChange = (selected) => {
    dispatch(setSelected({ tableType: selected }));
  };
  return (
    <div>
      <MultiSelectDropdown
        options={options}
        selectedFilters={selectedFilters}
        includeFilter={false}
        numberDisplayed={0}
        onSelectChange={(data) => onTableTypeChange(data)}
      />
    </div>
  );
};

export default TableTypeDropdown;
